<template>
  <viewInstance ref="view" :enums="enums" :form="form" :control="control">
    <entiteActions
      :demandeModication="demandeInstanceSuppressionPossible"
      :demandeSuppression="demandeInstanceSuppressionPossible"
      :enModeReactivation="this.enModeReactivation"
      :type="'instance'"
      :id="this.form.id"
    >
      <v-btn text v-if="this.enModeReactivation" @click="reactiverInstance">
        Réactiver
      </v-btn>
    </entiteActions>

    <template
      v-if="
        this.control.enDemandeModification ||
          this.control.enDemandeCreation ||
          this.control.enDemandeSuppression
      "
      #zoneBasse
    >
      <v-list-item>
        <v-list-item-content two-line class="pt-0">
          <v-list-item-title class="headline"
            >Raison de la demande</v-list-item-title
          >
          <v-list-item-subtitle
            >Veuillez saisir les raisons motivant cette
            demande</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>
      <v-card-text>
        <v-row dense>
          <v-col cols="12">
            <v-textarea
              counter
              filled
              label="Commentaire"
              v-model="commentaire"
              :rules="[size255Rule(), serveurRule('commentaire')]"
              hide-details="auto"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
    </template>
  </viewInstance>
</template>

<script>
import EditeurEntite from '@/plugins/mixins/EditeurEntite';
import { routeEnter, routeUpdate } from '@/utils/entite';
import ViewInstance from './ViewInstance';
import toasted from '@/utils/toasted';

const routesAction = (withId, withNew) => {
  withId(
    id => `instance/${id}`,
    (vm, body) => {
      vm.initForm(body);
    },
  );
  withNew('enums/instance', (vm, body) => vm.initNew(body));
};

export default {
  components: {
    viewInstance: ViewInstance,
  },
  props: {
    enModeCreation: {
      type: Boolean,
      default: false,
    },
    enModeReactivation: {
      type: Boolean,
      default: false,
    },
    enDemandeCreation: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [EditeurEntite],

  beforeRouteEnter: routeEnter(routesAction),
  beforeRouteUpdate: routeUpdate(routesAction),
  data() {
    return {
      // Configuration de l'IHM
      control: {
        readonly: true,
        enDemandeModification: false,
      },

      // Les enums
      enums: {
        typesInstance: [],
        typesParticipant: [],
      },
      commentaire: null,
      // Le formulaire
      form: {
        id: null,
        nom: null,
        description: null,
        urlSharepoint: null,
        typeInstance: null,
        referent: {
          id: null,
        },
        gestionnaires: [],
        participants: [],
        size: null,
        dateDebut: null,
        dateFin: null,
        dateCreation: null,
        chargeCreation: null,
        dateModification: null,
        chargeModification: null,
      },
    };
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  computed: {
    demandeInstanceSuppressionPossible() {
      return this.control.edition === 'DEMANDE' && !this.enModeReactivation;
    },
  },
  watch: {},
  methods: {
    // Gestion de l'initialisation du formulaire
    initForm(loaded) {
      //injection du droit d'edition
      this.control.edition = loaded.edition;

      this.form.dateCreation = loaded.dateCreation || null;
      this.form.chargeCreation = loaded.chargeCreation || null;
      this.form.dateModification = loaded.dateModification || null;
      this.form.demandeurCreation = loaded.demandeurCreation || null;
      this.form.chargeModification = loaded.chargeModification || null;

      this.form.id = loaded.id || null;
      this.form.nom = loaded.nom || null;
      this.form.urlSharepoint = loaded.urlSharepoint || null;
      this.form.description = loaded.description || null;

      this.form.typeInstance = loaded.typeInstance || null;
      this.form.referent = loaded.referent || { id: null };
      this.form.size = loaded.size || 0;
      this.form.fax = loaded.fax || null;
      this.form.dateDebut = loaded.dateDebut || null;
      this.form.dateFin = loaded.dateFin || null;

      // Collections
      this.form.gestionnaires = loaded.gestionnaires || [];
      this.form.participants = loaded.participants || [];

      this.control.size = this.form.size;
    },
    initNew(body) {
      this.initForm({
        gestionnaires: [],
        participants: [],
      });
      this.initEnums(body);
      this.__initEdition();

      //Question de droit : on fait une demande de creation ou une création directe
      this.control.enDemandeCreation = this.enDemandeCreation;
      this.control.enCreation = !this.enDemandeCreation;
      this.control.readonly = false;
      this.getForms().forEach(f => {
        if (f) {
          f.resetValidation();
        }
      });
    },

    resetForm() {
      this.initForm({});
    },
    // On initialise les tableaux d'enums avec les valeurs présentes dans le formulaire
    initEnumsForm() {
      this.enums.typesInstance = this.form.typesInstance;
      this.enums.typesParticipant = this.form.typesParticipant;
    },
    // Appelée après chargement des listes d'enums depuis le Back
    initEnums(body) {
      const enums = this.enums;
      enums.typesInstance = body.typesInstance;
      enums.typesParticipant = body.typesParticipant;
    },
    // On vide les enums pour gérer le updated()
    resetEnums() {
      const enums = this.enums;
      enums.typesInstance = [];
      enums.typesParticipant = [];
    },
    // Appelée par le mixin Entite
    creationPromiseEnums() {
      return this.$api('enums/instance')
        .get()
        .then(response => {
          const body = response.body;
          this.initEnums(body);
        });
    },

    redirectionApresCreation() {
      // Le callback pour aller vers le détail de la personne créer
      if (this.$auth.hasRole('PRIV_TRAITEMENT_DEMANDE_INSTANCE')) {
        const route = this.$liens().instance(this.form.id);
        this.control.readonly = true;
        this.$router.push(route);
      } else {
        this.$router.push({ name: 'workflow/mesdemandes' });
      }
    },
    creationPromiseSauvegarde(id, form) {
      const copy = { ...form };
      if (this.control.enCreation) {
        return this.$api('instance').put(copy);
      } else if (this.control.enDemandeModification) {
        copy.commentaire = this.commentaire;
        return this.$api(`workflow/instance/${id}`).post(copy);
      } else if (this.control.enDemandeCreation) {
        copy.commentaire = this.commentaire;
        return this.$api('workflow/instance').post(copy);
      } else if (this.control.enDemandeSuppression) {
        copy.commentaire = this.commentaire;
        return this.$api(`workflow/instance/suppression/${id}`).post(copy);
      }

      return this.$api(`instance/${id}`).post(form);
    },
    getForms() {
      //access aux formulaire à créer
      return this.$refs.view.getForms();
    },
    reactiverInstance() {
      const id = this.form.id;
      return this.$api(`workflow/instance/reactivation/${id}`)
        .post()
        .then(() => {
          toasted.info('Instance réactivée');
          this.$router.push({ name: 'administration/corbeille/corbeille' });
        });
    },
  },
};
</script>
